import React, { FC } from 'react';
import classNames from 'classnames/bind';

import styles from './index.pcss';
import Text from '../../../../../atoms/Text';
import Icon from '../../../../../atoms/Icon';
import Button from '../../../../../atoms/button';
import { onViewTnC } from '../../../../../../games/stw/methods/spinTheWheelMethods';

export interface ModalContentProps {
  modalHeader: string;
  list: List[];
  rewardList?: RewardData[];
  linkText?: string;
  href?: string;
  target?: string;
  fontSize?: 'xxs' | 'xs' | 'sm' | 'reg' | 'md';
  closeModal?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}
interface RewardData {
  label: string;
  desc: string;
}
interface List {
  text: string;
}
const cx = classNames.bind(styles);

const ModalContent: FC<ModalContentProps> = (props: ModalContentProps) => {
  const {
    isAppsFlag = false,
    modalHeader = '',
    list = [],
    rewardList = [],
    linkText = '',
    href = '',
    target = '',
    fontSize = '',
    platform = '',
    label = '',
    closeModal
  } = props;

  const handleBtnClick = () => {
    if (platform === 'app') {
      onViewTnC(isAppsFlag, platform, href);
    }
  };

  const createMarkup = item => {
    return { __html: item };
  };

  const listItem: JSX.Element[] = () => {
    return list.map(
      (item, index): JSX.Element => {
        return (
          <li key={index} dangerouslySetInnerHTML={createMarkup(item)}>
            {/* <Text variant="T2" color="Nero" weight="regular">
              {item}
            </Text> */}
          </li>
        );
      }
    );
  };
  const rewardJsx: JSX.Element[] = () => {
    return rewardList.map((item, index) => {
      return (
        <li key={index}>
          <div>
            <Text variant="T4" color="Nero" weight="bold">
              {item.label}
            </Text>
          </div>
          <div>
            <Text variant="T2" color="Dark_Grey" weight="regular">
              {item.desc}
            </Text>
          </div>
        </li>
      );
    });
  };
  const classes = cx('modal-content', {
    'modal-content-margin': platform === 'website'
  });
  return (
    <div className={classes}>
      <div className={cx('modal-header')}>
        <Text variant="T5" color="Nero" weight="bold">
          {modalHeader}
        </Text>
        <Icon icon="icon-Close" onClick={closeModal} ariaLabel="close" />
      </div>
      <ul className={cx('modal-list')}>{listItem()}</ul>
      {rewardList.length ? (
        <div className={cx('modal-reward')}>
          <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized">
            **Reward Structure
          </Text>
          <ul className={cx('modal-reward-list')}>{rewardJsx()}</ul>
        </div>
      ) : null}
      {linkText && (
        <div className={cx('modal-link-btn')}>
          <Button
            variant="link"
            btnLabel={linkText}
            fontSize={fontSize}
            href={href}
            target={target}
            onClick={handleBtnClick}
          />
        </div>
      )}
      {platform !== 'website' ? (
        <div className={cx('modal-close')}>
          <Button btnLabel={label || 'Close'} fullWidth onClick={closeModal} />
        </div>
      ) : null}
    </div>
  );
};

ModalContent.defaultProps = {
  modalHeader: '',
  list: [],
  rewardList: [],
  linkText: '',
  href: '',
  fontSize: 'sm',
  target: '',
  closeModal: () => {}
};

export default ModalContent;
